import * as React from "react";
import { forwardRef } from "react";
const SvgArrowGreyRightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.16602 7H12.8327M12.8327 7L6.99935 1.16667M12.8327 7L6.99935 12.8333", stroke: "#475467", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowGreyRightIcon);
export { ForwardRef as ReactComponent };
